
import ImageBox from '../imageBox/index.jsx'
import SlideBar1 from '../slideBar1/index.jsx'
import './side.less'
import React from 'react'
console.log(React)
export default function BasicsSide(props) {
  return (<div className='basicsImageSide'>
    <div className='basicsImageSide_no1'>
      <h3 className='title'>基础组件：图片</h3>
      <div className='tips'>支持腾讯广告全广告位</div>
    </div>
    <div className='basicsImageSide_no2'>
      <h3 className='no2_title'>素材设置</h3>
      <div className='no2_box'>
        <span className='box_title'>图片素材</span>
        <div className='box_main'>
          <div className='main_img'>
            <ImageBox src={props.ifon.imageIfon.path} change={props.hoistPopup} mySwitch={props.hoistPopup}></ImageBox>
          </div>
          <div className='main_text'>
            暂不支持含有二维码的图片<br />
            图片格式：大小不超过300KB，不支持Gif<br />
            图片尺寸：宽度750像素，高度不超过1536像素<br />
          </div>
        </div>
      </div>
    </div>

    <div className='basicsImageSide_no3'>
      <h3 className='no3_title'>边距</h3>
      <div className='no3_main'>
        <div className='main_item'>
          <SlideBar1 title={'上边距'} value={props.ifon.padding_top} speed={(value) => {
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              padding_top: value
            })
          }}></SlideBar1>
        </div>
        <div className='main_item'>
          <SlideBar1 title={'下边距'} value={props.ifon.padding_bottom} speed={(value) => {
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              padding_bottom: value
            })
          }}></SlideBar1>
        </div>
      </div>
    </div>
  </div>)
}
